import { z } from 'zod'

const kStoragePrefix = 'user-skill-attachments:'
const kAttachedSkillNamesSchema = z.record(z.string(), z.array(z.string()))

// Display-only tab cache. Storage failures must not prevent sending or loading chat.
export function readAttachedSkillNames(userId: string, conversationId: string): Record<string, string[]> {
  try {
    const stored = sessionStorage.getItem(`${kStoragePrefix}${userId}:${conversationId}`)
    if (!stored) return {}
    const parsed = kAttachedSkillNamesSchema.safeParse(JSON.parse(stored))
    return parsed.success ? parsed.data : {}
  } catch {
    return {}
  }
}

export function saveAttachedSkillNames(userId: string, conversationId: string, clientRequestId: string, names: string[]) {
  try {
    const namesByRequestId = readAttachedSkillNames(userId, conversationId)
    namesByRequestId[clientRequestId] = names
    sessionStorage.setItem(`${kStoragePrefix}${userId}:${conversationId}`, JSON.stringify(namesByRequestId))
  } catch {
    // The optimistic message still shows the chips if browser storage is unavailable.
  }
}

export function clearAttachedSkillNames() {
  try {
    for (let index = sessionStorage.length - 1; index >= 0; index--) {
      const key = sessionStorage.key(index)
      if (key?.startsWith(kStoragePrefix)) sessionStorage.removeItem(key)
    }
  } catch {
    // Browser storage is optional; clearing application state must still complete.
  }
}
